import { ViewFactory } from 'src/3rds/cube-react'

import { WaitingScope } from '../waiting.scopes'
import { WaitingView } from './waiting.view'

export function registerViews(rv = ViewFactory.register) {
    rv(WaitingScope, WaitingView)
}